export default [
  {
    path: '/sincronizacoes',
    name: 'Sincronizações',
    meta: { descricao: 'Sincronizações' },
    component: () => import('@/pages/sincronizacoes/Sincronizacoes')
  }
]
